<template>
  <div id="Overview" class="reportHeader">
    <div class="pageHeader">
      <div class="row">
        <div class="col-xs-12">
          <hr />
        </div>
      </div>

      <div class="row">
        <div class="col-xs-6">
          <div class="flag-icon mr-2" :class="countryFlagIconClass" />
          <span class="label" :class="'label-' + companyOverviewStatusLabelClass">
            {{ simpleStatusName }}
          </span>&nbsp;&nbsp;
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from '@/packages/axios/Axios';
import CompaniesTools from '@/components/companies/Tools';

export default {
  computed: {
    countryFlagIconClass() {
      if (
        this.companyOverview.registered_address !== undefined
        && this.companyOverview.registered_address.country !== undefined
        && this.companyOverview.registered_address.country.code !== undefined
      ) {
        return 'flag-icon-' + this.companyOverview.registered_address.country.code.toLowerCase();
      }
      return '';
    },
    simpleStatusName() {
      if (this.companyOverview && this.companyOverview.simplestatus) {
        return this.companyOverview.simplestatus.name;
      }
      return 'N/A';
    },
  },
  mixins: [CompaniesTools],
  name: 'CompanyHeading',
  props: {
    companyOverview: {
      required: true,
      type: Object,
    },
  },
};
</script>

<style scoped>
</style>
